import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import heroBackground from "@/assets/hero-background.jpg";

interface HeroSectionProps {
  onScrollToResources: () => void;
}

const HeroSection = ({ onScrollToResources }: HeroSectionProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const navigate = useNavigate();

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      navigate(`/templates?search=${encodeURIComponent(searchQuery)}`);
    } else {
      onScrollToResources();
    }
  };

  return (
    <section className="relative min-h-[70vh] flex items-center">
      {/* Full-size Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${heroBackground})` }}
      >
        <div className="absolute inset-0 bg-black/50" />
      </div>

      {/* Content Section */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white mb-3">
          Download free templates. <span className="text-white/80">FTS Innovation Hub.</span>
        </h1>
        
        <p className="text-lg text-white/90 mb-8 max-w-2xl">
          Access premium project management templates and join a thriving community of professionals.
        </p>

        {/* Search Bar */}
        <form onSubmit={handleSearch} className="max-w-2xl mb-6">
          <div className="relative flex items-center">
            <Input
              type="text"
              placeholder="What do you want to learn?"
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
              className="h-14 pl-4 pr-12 text-base border-0 rounded-md bg-white/95 w-full shadow-lg"
            />
            <button type="submit" className="absolute right-4">
              <Search className="h-5 w-5 text-muted-foreground" />
            </button>
          </div>
        </form>
      </div>
    </section>
  );
};

export default HeroSection;
